import React from 'react'
import { OneColorIconProps, getHexColor } from '../utils'

export const VisibilityOnIcon: React.FC<OneColorIconProps & { sWidth?: string }> = ({ size = 22, color = 'white' }) => {
  const hex = getHexColor(color)

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path
        d="M12 4.275C14.3834 4.275 16.525 4.90417 18.425 6.1625C20.325 7.42083 21.75 9.05833 22.7 11.075C22.75 11.1583 22.7834 11.2625 22.8 11.3875C22.8167 11.5125 22.825 11.6417 22.825 11.775C22.825 11.9083 22.8125 12.0375 22.7875 12.1625C22.7626 12.2875 22.7334 12.3917 22.7 12.475C22.3167 13.325 21.8375 14.1083 21.2625 14.825C20.6875 15.5417 20.0334 16.175 19.3 16.725C18.7709 17.1542 18.1875 17.525 17.55 17.8375C15.825 18.6917 13.9917 19.1375 12 19.1375C9.61672 19.1375 7.47505 18.5083 5.57505 17.25C3.67505 15.9917 2.25005 14.3542 1.30005 12.3375C1.25005 12.2542 1.21672 12.15 1.20005 12.025C1.18338 11.9 1.17505 11.7708 1.17505 11.6375C1.17505 11.5042 1.18338 11.3792 1.20005 11.2625C1.21672 11.1458 1.25005 11.0458 1.30005 10.9625C2.25005 8.94583 3.67505 7.30833 5.57505 6.05C7.47505 4.79167 9.61672 4.1625 12 4.1625V4.275Z"
        stroke={hex}
        strokeWidth="2"
        fill="none"
      />
      <circle cx="12" cy="11.775" r="3.25" stroke={hex} strokeWidth="2" fill="none" />
    </svg>
  )
}
